<div class="form-builder-container">
  <p-toast></p-toast>
  <p-confirmDialog #cd [style]="{'max-width': '60vw', 'width': '60vw'}" styleClass="custom-confirm-dialog">
    <ng-template pTemplate="headless" let-message>
      <div class="flex flex-col items-center p-8 bg-white rounded-2xl relative">
        <div class="absolute -top-10 w-24 h-24 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-lg animate-bounce-in">
          <i class="pi pi-exclamation-triangle text-5xl text-white"></i>
        </div>
        <div class="mt-16 text-center w-full">
          <h3 class="text-2xl font-bold text-gray-900 mb-3">
            {{ message.header }}
          </h3>
          <p class="text-base text-gray-600 leading-relaxed px-4 mb-6">
            {{ message.message }}
          </p>
          <div class="flex items-center justify-center gap-3 mt-6">
            <button pButton type="button" [label]="message.acceptLabel || 'Yes, Continue'"
              (click)="message.accept && message.accept()"
              [loading]="publishingForm || deletingForm"
              [disabled]="publishingForm || deletingForm"
              class="px-8 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-200 transform hover:-translate-y-0.5">
            </button>
            <button *ngIf="message.rejectVisible !== false" pButton type="button"
              [label]="message.rejectLabel || 'Cancel'" (click)="message.reject && message.reject()"
              [disabled]="publishingForm || deletingForm"
              class="px-8 py-3 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200">
            </button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-confirmDialog>

  <div class="">
    <div class="flex justify-between items-center mb-8">
      <div>
        <h2 class="text-4xl font-bold mb-3" style="background: linear-gradient(90deg, #3b82f6, #8b5cf6); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">
          <i class="pi pi-file-edit mr-3"></i>Dynamic Form Builder
        </h2>
        <p class="text-gray-600 text-lg">Create and manage dynamic forms for Leads, Registration, and Application modules</p>
      </div>
      <p-button 
        label="Create New Form" 
        icon="pi pi-plus" 
        (onClick)="openNewFormDialog()"
        styleClass="p-button-primary"
        [style]="{'padding': '0.75rem 1.5rem', 'font-weight': '600', 'border-radius': '12px', 'box-shadow': '0 4px 12px rgba(59, 130, 246, 0.3)'}">
      </p-button>
    </div>

    <!-- Forms List -->
    <div *ngIf="!loading && forms.length > 0">
      <p-table 
        [value]="forms" 
        [paginator]="true" 
        [rows]="10"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} forms"
        [rowsPerPageOptions]="[10, 25, 50]"
        styleClass="p-datatable-sm">
        
        <ng-template pTemplate="header">
          <tr>
            <th>Form Name</th>
            <th>Module</th>
            <!-- <th>Fields</th> -->
            <th>Status</th>
            <th>Created</th>
            <th style="width: 250px;">Actions</th>
          </tr>
        </ng-template>
        
        <ng-template pTemplate="body" let-form>
          <tr>
            <td>
              <strong>{{ form.form_name }}</strong>
              <br>
              <small class="text-gray-500">{{ form.description }}</small>
            </td>
            <td>
              <p-chip [label]="form.module_name" styleClass="custom-chip"></p-chip>
            </td>
            <!-- <td>
              <span class="text-blue-600 font-semibold">{{ form.fields?.length || 0 }}</span> fields
            </td> -->
            <td>
              <p-chip 
                [label]="form.is_published ? 'Published' : 'Draft'" 
                [styleClass]="form.is_published ? 'p-chip-success' : 'p-chip-warning'">
              </p-chip>
            </td>
            <td>
              <small>{{ form.created_at | date:'short' }}</small>
            </td>
            <td>
              <div class="flex gap-2">
                <p-button 
                  icon="pi pi-pencil" 
                  [text]="true"
                  [rounded]="true"
                  severity="info"
                  pTooltip="Edit Form"
                  tooltipPosition="top"
                  (onClick)="editForm(form)">
                </p-button>
                
                <p-button 
                  *ngIf="!form.is_published"
                  icon="pi pi-check-circle" 
                  [text]="true"
                  [rounded]="true"
                  severity="success"
                  pTooltip="Publish Form"
                  tooltipPosition="top"
                  (onClick)="publishForm(form)">
                </p-button>
                
                <p-button 
                  *ngIf="form.is_published"
                  icon="pi pi-times-circle" 
                  [text]="true"
                  [rounded]="true"
                  pTooltip="Unpublish Form"
                  tooltipPosition="top"
                  (onClick)="unpublishForm(form)">
                </p-button>
                
                <p-button 
                  *ngIf="form.is_published && form.public_token"
                  icon="pi pi-copy" 
                  [text]="true"
                  [rounded]="true"
                  severity="secondary"
                  pTooltip="Copy Public URL"
                  tooltipPosition="top"
                  (onClick)="copyPublicUrl(form)">
                </p-button>

                <p-button 
                  *ngIf="form.is_published && form.public_token"
                  icon="pi pi-code" 
                  [text]="true"
                  [rounded]="true"
                  severity="info"
                  pTooltip="Get Embed Code"
                  tooltipPosition="top"
                  (onClick)="openEmbedCodeDialog(form)">
                </p-button>
                
                <p-button 
                  icon="pi pi-trash" 
                  [text]="true"
                  [rounded]="true"
                  severity="danger"
                  pTooltip="Delete Form"
                  tooltipPosition="top"
                  (onClick)="deleteForm(form)">
                </p-button>
              </div>
            </td>
          </tr>
        </ng-template>
        
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center py-8">
              <i class="pi pi-inbox text-6xl text-gray-300 mb-3"></i>
              <p class="text-gray-500">No forms found. Create your first form!</p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="text-center py-8">
      <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="2"></p-progressSpinner>
      <p class="mt-3 text-gray-600">Loading forms...</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && forms.length === 0" class="text-center py-16" style="background: linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%); border-radius: 16px; border: 2px dashed #c7d2fe;">
      <div class="inline-block p-6 rounded-full" style="background: linear-gradient(135deg, #dbeafe 0%, #c7d2fe 100%); box-shadow: 0 8px 24px rgba(59, 130, 246, 0.2);">
        <i class="pi pi-file text-6xl" style="background: linear-gradient(90deg, #3b82f6, #8b5cf6); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;"></i>
      </div>
      <h3 class="text-3xl font-bold mb-3 mt-6" style="color: #1e293b;">No Forms Yet</h3>
      <p class="text-gray-600 mb-8 text-lg">Get started by creating your first dynamic form</p>
      <p-button 
        label="Create First Form" 
        icon="pi pi-plus" 
        (onClick)="openNewFormDialog()"
        styleClass="p-button-primary p-button-lg"
        [style]="{'padding': '1rem 2rem', 'font-size': '1.125rem', 'border-radius': '12px', 'box-shadow': '0 4px 12px rgba(59, 130, 246, 0.3)'}">
      </p-button>
    </div>
  </div>

  <!-- Form Builder Dialog -->
  <p-dialog 
    [(visible)]="showFormDialog" 
    [modal]="true" 
    [breakpoints]="{ '1199px': '95vw', '575px': '98vw' }"
    [style]="{width: '95vw', height: '95vh'}"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="closeFormDialog()">
    
    <ng-container *ngIf="showFormDialog">
    <ng-template pTemplate="header">
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center">
          <i class="pi pi-file-edit mr-2"></i>
          <span class="font-semibold">{{ isEditMode ? 'Edit Form' : 'Create New Form' }}</span>
        </div>
      </div>
    </ng-template>

    <app-create-form
      [form]="currentForm"
      [availableFields]="availableFields"
      [availableModules]="availableModules"
      [isEditMode]="isEditMode"
      [loadingFields]="loadingFields"
      [savingForm]="savingForm"
      (onSave)="saveForm()"
      (onCancel)="closeFormDialog()"
      (onModuleChange)="onModuleChange()">
    </app-create-form>
    </ng-container>
  </p-dialog>

  <!-- Embed Code Dialog -->
  <p-dialog 
    [(visible)]="showEmbedCodeDialog" 
    [modal]="true" 
    [breakpoints]="{ '576px': '90vw' }"
    [style]="{width: '600px'}"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="closeEmbedCodeDialog()">
    
    <ng-template pTemplate="header">
      <div class="flex items-center">
        <i class="pi pi-code mr-2"></i>
        <span class="font-semibold">Embed Code</span>
      </div>
    </ng-template>

    <div *ngIf="embedCodeForm" class="space-y-6 dialog-content">
      <div>
        <h4 class="text-sm font-semibold text-gray-700 mb-3">Form Name: <span class="text-blue-600">{{ embedCodeForm.form_name }}</span></h4>
        <p class="text-sm text-gray-600 mb-4">Copy this code and paste it into your website's HTML to embed this form:</p>
      </div>

      <!-- Code Display -->
      <div class="bg-gray-900 rounded-lg p-4 overflow-x-auto">
        <pre class="text-gray-100 text-xs language-html"><code>{{ embedCode }}</code></pre>
      </div>

      <!-- Copy Button -->
      <div class="flex gap-3">
        <p-button 
          icon="pi pi-copy" 
          [label]="'Copy to Clipboard'"
          (onClick)="copyEmbedCode()"
          styleClass="p-button-primary flex-1"
          [style]="{'padding': '0.75rem 1.5rem', 'font-weight': '600', 'border-radius': '8px'}">
        </p-button>
        <p-button 
          icon="pi pi-times" 
          [label]="'Close'"
          (onClick)="closeEmbedCodeDialog()"
          styleClass="p-button-secondary flex-1"
          [style]="{'padding': '0.75rem 1.5rem', 'font-weight': '600', 'border-radius': '8px'}">
        </p-button>
      </div>

      <!-- Information -->
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p class="text-xs text-blue-800">
          <i class="pi pi-info-circle mr-2"></i>
          This iframe will embed the form into your website. Adjust the width and height attributes as needed.
        </p>
      </div>
    </div>
  </p-dialog>
</div>
